module.exports = __webpack_public_path__ + "static/media/scene_gen_icon.27190f96.png";